import axios from "axios";

const baseURL = `${process.env.REACT_APP_BASE_URL}/v1/api`;

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response.data,
  (error) =>
    Promise.reject(
      error.response?.data || error.message || "Unknown API error occurred"
    )
);

export default api;

